<template>
  <q-banner class="banner rounded-borders text-red-10 bg-red-1" dense>
    <div class="row items-start no-wrap" :class="{ 'text-no-wrap': !wrap }">
      <div><q-icon class="icon q-mr-xs" name="warning" size="xs" /></div>
      <div><slot /></div>
    </div>
  </q-banner>
</template>

<script setup lang="ts">
defineProps<{ wrap?: boolean }>();
</script>

<style scoped lang="scss">
.banner {
  border: 1px solid $red-2;
}

.icon {
  top: -1px;
  position: relative;
}
</style>
